import React from "react";
import { Input, Select } from "antd";
import BuildFormLabel from "./BuildFormLabel";
import NativeTemplateAssetUpload from "../NativeTemplateUpload";

const { Option } = Select;

const BuildFormInputTypes = ({ field, form, childConfig, assetTypeLength }) => {
    let {
        defaultValue,
        description,
        label,
        value,
        type,
        isRequired,
        choices,
        uniqueName,
        length,
    } = field;
    const { getFieldDecorator } = form;
    if (typeof choices === "string") choices = choices.split(",");
    switch (true) {
        case type === "Asset":
            return (
                <BuildFormLabel
                    label={label}
                    description={description}
                    isRequired={
                        isRequired &&
                        (childConfig.currentMatspec.assetcount !== 1 &&
                            assetTypeLength !== 1)
                    }
                    inputComponent={
                        <NativeTemplateAssetUpload
                            label={label}
                            childConfig={childConfig}
                        />
                    }
                    /* inputType={"number"} */
                    getFieldDecorator={getFieldDecorator}
                    uniqueName={uniqueName}
                    initialValue={value || defaultValue}
                    errorMissing={"This field is required."}
                    errorInvalid={"This field is not valid, please correct."}
                    translations={childConfig.translations}
                />
            );
            break;

        case type === "file":
            return (
                <BuildFormLabel
                    label={label}
                    description={description}
                    isRequired={false}
                    inputComponent={
                        <NativeTemplateAssetUpload
                            label={label}
                            childConfig={childConfig}
                        />
                    }
                    /* inputType={"number"} */
                    getFieldDecorator={getFieldDecorator}
                    uniqueName={uniqueName}
                    initialValue={value || defaultValue}
                    errorMissing={defaultValue ? undefined : "This field is required."}
                    errorInvalid={"This field is not valid, please correct."}
                    translations={childConfig.translations}
                />
            );
            break;

        case type === "String":
        case type === "string":
            return (
                <BuildFormLabel
                    label={label}
                    description={description}
                    isRequired={isRequired}
                    inputComponent={
                        <Input placeholder={length ? `max ${length} characters` : `${label} (${type})`} maxLength={length} />
                    }
                    getFieldDecorator={getFieldDecorator}
                    uniqueName={uniqueName}
                    initialValue={value || defaultValue || null}
                    errorMissing={"This field is required."}
                    errorInvalid={"This field is not valid, please correct."}
                    translations={childConfig.translations}
                />
            );
        case type === "url" || type === "Url":
            return (
                <BuildFormLabel
                    label={label}
                    description={description}
                    isRequired={isRequired}
                    inputComponent={
                        <Input placeholder={`${label} (${type})`} />
                    }
                    /*inputType={"url"}*/
                    getFieldDecorator={getFieldDecorator}
                    uniqueName={uniqueName}
                    initialValue={value || defaultValue || null}
                    errorMissing={"This field is required."}
                    errorInvalid={"This field is not valid, please correct."}
                    translations={childConfig.translations}
                />
            );
            break;

        case type === "Long":
            return (
                <BuildFormLabel
                    label={label}
                    description={description}
                    isRequired={isRequired}
                    inputComponent={
                        <Input
                            type="number"
                            placeholder={`${label} (${type})`}
                        />
                    }
                    /*inputType={"number"}*/
                    getFieldDecorator={getFieldDecorator}
                    uniqueName={uniqueName}
                    initialValue={value || defaultValue || null}
                    errorMissing={"This field is required."}
                    errorInvalid={"This field is not valid, please correct."}
                    translations={childConfig.translations}
                />
            );
            break;

        case type === "ListString":
            return (
                <BuildFormLabel
                    label={label}
                    description={description}
                    isRequired={isRequired}
                    inputComponent={
                        choices && choices.length ? (
                            <Select>
                                <Option value="0">
                                    Please Select an option
                                </Option>
                                {choices &&
                                    choices.map((choice) => {
                                        const { label, value } = choice;
                                        return (
                                            <Option value={value} key={label}>
                                                {label}
                                            </Option>
                                        );
                                    })}
                            </Select>
                        ) : (
                                <Input placeholder={`${label} (${type})`} />
                            )
                    }
                    inputType={"string"}
                    getFieldDecorator={getFieldDecorator}
                    uniqueName={uniqueName}
                    initialValue={value || defaultValue || "0"}
                    errorMissing={"This field is required."}
                    errorInvalid={"This field is not valid, please correct."}
                    translations={childConfig.translations}
                />
            );
            break;

        case type === "integer":
            return (
                <BuildFormLabel
                    label={label}
                    description={description}
                    isRequired={isRequired}
                    inputComponent={
                        <Input placeholder={`${label} (${type})`} />
                    }
                    inputComponent={
                        <Input
                            type="number"
                            placeholder={`${label} (${type})`}
                        />
                    }
                    /*inputType={"number"}*/
                    getFieldDecorator={getFieldDecorator}
                    uniqueName={uniqueName}
                    initialValue={value || defaultValue || null}
                    errorMissing={"This field is required."}
                    errorInvalid={"This field is not valid, please correct."}
                    translations={childConfig.translations}
                />
            );
            break;

        case type === "decimal":
            return (
                <BuildFormLabel
                    label={label}
                    description={description}
                    isRequired={isRequired}
                    inputComponent={
                        <Input placeholder={`${label} (${type})`} />
                    }
                    /* inputType={"number"} */
                    getFieldDecorator={getFieldDecorator}
                    uniqueName={uniqueName}
                    initialValue={value || defaultValue || null}
                    errorMissing={"This field is required."}
                    errorInvalid={"This field is not valid, please correct."}
                    translations={childConfig.translations}
                />
            );
            break;

        case type === "true_false":
            return (
                <BuildFormLabel
                    label={label}
                    description={description}
                    isRequired={isRequired}
                    inputComponent={
                        <Select>
                            <Option value="-1">Please Select an option</Option>
                            <Option value="1" key="true">
                                true
                            </Option>
                            <Option value="0" key="false">
                                false
                            </Option>
                        </Select>
                    }
                    /* inputType={"number"} */
                    getFieldDecorator={getFieldDecorator}
                    uniqueName={uniqueName}
                    initialValue={value || defaultValue || null}
                    errorMissing={"This field is required."}
                    errorInvalid={"This field is not valid, please correct."}
                    translations={childConfig.translations}
                />
            );
            break;

        case type === "select_from_list":
            return (
                <BuildFormLabel
                    label={label}
                    description={description}
                    isRequired={isRequired}
                    inputComponent={
                        <Select>
                            <Option value="0">Please Select an option</Option>
                            {choices &&
                                choices.map((choice) => {
                                    return (
                                        <Option value={choice} key={choice}>
                                            {choice}
                                        </Option>
                                    );
                                })}
                        </Select>
                    }
                    getFieldDecorator={getFieldDecorator}
                    uniqueName={uniqueName}
                    initialValue={value || defaultValue || null}
                    errorMissing={"This field is required."}
                    errorInvalid={"This field is not valid, please correct."}
                    translations={childConfig.translations}
                />
            );
            break;

        default:
            return <div>{`NOT SET ==> ${type}`}</div>;
            break;
    }
};

export default BuildFormInputTypes;

//   inputComponent={
//     <AssetUpload
//       admaterialUploaded={() => admaterialUploaded()}
//       admaterialUploading={() => admaterialUploading()}
//       dropAssets={translations.dropAssets}
//       language={fieldTranslations}
//       materialSpecificationId={
//         record.materialSpecificationId
//           ? record.materialSpecificationId
//           : null
//       }
//       printAd={record.digitalmatspec ? "DIGITAL" : "PRINTED"}
//       setNewAssets={() => setNewAssets()}
//       specId={record.id}
//       status={record.status.code}
//       submitting={() => submitting()}
//       translations={translations}
//       loadConfig={loadConfig}
//       unsubmittedChanges={()=>unsubmittedChanges()}
//     />
//   }



// WEBPACK FOOTER //
// ./src/components/NativeTemplates/Helpers/BuildFormInputTypes.js